import { render, staticRenderFns } from "./MessageRegisterDetail.vue?vue&type=template&id=4347db32&scoped=true&lang=pug"
import script from "./MessageRegisterDetail.vue?vue&type=script&lang=ts"
export * from "./MessageRegisterDetail.vue?vue&type=script&lang=ts"
import style0 from "./MessageRegisterDetail.vue?vue&type=style&index=0&id=4347db32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4347db32",
  null
  
)

export default component.exports